import script from "./OverrideHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./OverrideHistory.vue?vue&type=script&setup=true&lang=js"

import "./OverrideHistory.vue?vue&type=style&index=0&id=a94ecb18&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a94ecb18"]])

export default __exports__